import { render, staticRenderFns } from "./ProductsList.vue?vue&type=template&id=1d3d91e6&"
import script from "./ProductsList.vue?vue&type=script&lang=js&"
export * from "./ProductsList.vue?vue&type=script&lang=js&"
import style0 from "./ProductsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\websites\\newshop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d3d91e6')) {
      api.createRecord('1d3d91e6', component.options)
    } else {
      api.reload('1d3d91e6', component.options)
    }
    module.hot.accept("./ProductsList.vue?vue&type=template&id=1d3d91e6&", function () {
      api.rerender('1d3d91e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ProductsList.vue"
export default component.exports